import { WrappedFieldProps } from 'redux-form';
import styled from 'styled-components';

import FormError from 'dashboard/components/FormControls/FormError';
import { COLORS } from 'dashboard/styles/variables';
import Checkbox from 'design-system/components/Checkbox';

const Container = styled('div')`
  display: flex;
  align-items: center;
  color: ${COLORS.gray100};
`;

export interface CheckboxFieldProps {
  autoFocus?: boolean;
  id?: string;
  label?: string;
  className?: string;
}

const CheckboxField = (props: WrappedFieldProps & CheckboxFieldProps) => {
  const {
    className,
    input,
    meta: { error, submitFailed, touched },
    autoFocus,
    label,
    id,
    ...passthroughProps
  } = props;

  const hasError = !!(error && (submitFailed || touched));

  return (
    <>
      <Container className={className}>
        <Checkbox
          {...input}
          {...passthroughProps}
          autoFocus={autoFocus}
          id={id}
          checked={input.value}
          label={label}
        />
      </Container>
      {hasError && <FormError>{error}</FormError>}
    </>
  );
};

export default CheckboxField;
